"use strict";

jQuery(document).ready(function ($) {
  $('.image-carousel__default').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
  $('.image-carousel__double--1').slick({
    arrows: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.image-carousel__double--3'
  });
  $('.image-carousel__double--3').slick({
    centerMode: true,
    centerPadding: 0,
    arrows: true,
    prevArrow: '<span class="image-carousel__arrow--prev slider__arrow--prev"><svg width="52" height="38" viewBox="0 0 52 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9351 38L27.6883 38C27.537 31.8657 24.625 26.1196 19.7735 22.3929L19.7357 18.772L19.6871 17.2004L19.7735 15.6071C24.625 11.8804 27.537 6.13428 27.6883 -2.1254e-06L20.9351 -2.71578e-06C20.9351 8.60428 11.5345 15.6071 1.95765e-06 15.6071L1.36442e-06 22.3929C11.5345 22.3929 20.9351 29.3957 20.9351 38Z" fill="#D4C53B"/>\n' + '  <path d="M52 21.7143L19.5844 21.7143L19.5844 16.2857L52 16.2857L52 21.7143Z" fill="#D4C53B"/>\n' + '  </svg>\n</span>',
    nextArrow: '<span class="image-carousel__arrow--next slider__arrow--next"><svg width="52" height="38" viewBox="0 0 52 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '  <path fill-rule="evenodd" clip-rule="evenodd" d="M31.0649 0H24.3117C24.463 6.13429 27.375 11.8804 32.2265 15.6071L32.2643 19.228L32.3129 20.7996L32.2265 22.3929C27.375 26.1196 24.463 31.8657 24.3117 38H31.0649C31.0649 29.3957 40.4655 22.3929 52 22.3929V15.6071C40.4655 15.6071 31.0649 8.60429 31.0649 0Z" fill="#D4C53B"/>\n' + '  <path d="M0 16.2857H32.4156V21.7143H0V16.2857Z" fill="#D4C53B"/>\n' + '  </svg>\n</span>',
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.image-carousel__double--1',
    dots: false,
    focusOnSelect: true
  });
});